import type { StreamPoint } from './workoutStream';

// Match the analysis chart gap policy across desktop and mobile clients.
const MAX_RECORDING_GAP_SEC = 30;

/** Time-weighted paired power/HR ratios in the two elapsed-time halves.
 * A short selection is still calculable; absent data is not zero decoupling.
 */
export function selectionDecoupling(stream: StreamPoint[], startIdx: number, endIdx: number): number | null {
  const lo = Math.max(0, Math.min(startIdx, endIdx));
  const hi = Math.min(stream.length - 1, Math.max(startIdx, endIdx));
  if (hi <= lo) return null;
  const start = stream[lo].timeSeconds;
  const end = stream[hi].timeSeconds;
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null;
  const mid = (start + end) / 2;
  const halves = [{ power: 0, hr: 0, duration: 0 }, { power: 0, hr: 0, duration: 0 }];
  for (let i = lo; i < hi; i++) {
    const point = stream[i];
    const next = stream[i + 1].timeSeconds;
    const dt = next - point.timeSeconds;
    if (point.paused || dt <= 0 || dt > MAX_RECORDING_GAP_SEC || !Number.isFinite(dt)
      || point.power == null || !Number.isFinite(point.power) || point.power < 0
      || point.heartRate == null || !Number.isFinite(point.heartRate) || point.heartRate <= 0) continue;
    for (let half = 0; half < 2; half++) {
      const duration = Math.max(0, Math.min(next, half === 0 ? mid : end) - Math.max(point.timeSeconds, half === 0 ? start : mid));
      halves[half].power += point.power * duration;
      halves[half].hr += point.heartRate * duration;
      halves[half].duration += duration;
    }
  }
  if (halves.some(half => half.duration <= 0 || half.hr <= 0 || half.power <= 0)) return null;
  const first = halves[0].power / halves[0].hr;
  const second = halves[1].power / halves[1].hr;
  return (first - second) / first * 100;
}
